const deleteRoles = {
  toastr: 'Função deletada',
  toastr1: ' deletado com sucesso'
};

export default deleteRoles;
